import type { RuntimeMetrics } from "../lib/usePerformance";

export function PerfHud({ metrics }: { metrics: RuntimeMetrics }) {
  const state = metrics.fps >= 52 ? "good" : metrics.fps >= 42 ? "warn" : "hot";
  return (
    <aside className={`perf-hud ${state}`} aria-label="Runtime performance">
      <span className="perf-dot" />
      <dl>
        <div><dt>FPS</dt><dd>{metrics.fps}</dd></div>
        <div><dt>P75 frame</dt><dd>{metrics.frame} ms</dd></div>
        <div><dt>Long tasks</dt><dd>{metrics.longTasks}</dd></div>
      </dl>
    </aside>
  );
}
